
import React from "react";
import { IDragDroppedFile } from "../state/CorporateArchiveStates/LegalEntityDocumentsStateOutlook";
import { IDragDropTarget, OutlookDragDropManager } from "./OutlookDragDropManager";
import { makeAutoObservable } from "mobx";
import { observer } from "mobx-react";

//3. implement notifyDragEnter, notifyDragLeave, notifyDrop
export class DragDropTargetState implements IDragDropTarget {
    private dropTargetId: string;
    private elementRef: HTMLElement | null = null;
    manager: OutlookDragDropManager;
    private enter: () => void = () => { };
    private leave: () => void = () => { };
    private hover: () => void = () => { };
    private drop?: (files: IDragDroppedFile[]) => Promise<void>;
    expandTimeout: any;

    constructor(manager: OutlookDragDropManager) {
        this.manager = manager;
        this.dropTargetId = `drop-target-${Math.random()}`;

        makeAutoObservable(this);
    }

    public onDrop(drop: (files: IDragDroppedFile[]) => Promise<void>) {
        this.drop = drop;
    }

    public onHover(h: () => void) {
        this.hover = h;
    }

    public isActive: boolean = false;
    public setIsActive(v: boolean) {
        this.isActive = v;

        if (this.expandTimeout) {
            clearTimeout(this.expandTimeout);
        }

        //Start a timer to auto-expand after a delay
        if (v) {
            this.expandTimeout = setTimeout(() => {
                this.hover();
            }, 600);
        }
    }

    public notifyDragEnter() {
        this.setIsActive(true);
        this.enter();
    }

    public notifyDragLeave(): void {
        this.setIsActive(false);
        this.leave();
    }

    public async notifyDrop(files: IDragDroppedFile[]): Promise<void> {
        if (this.drop)
            await this.drop(files);
    }

    public getUniqueDragDropId(): string {
        return this.dropTargetId;
    }

    public getElementRef(): HTMLElement | null {
        return this.elementRef;
    }

    public registerForDragDrop(element: HTMLElement | null): void {
        // Register this folder as a drop target
        if (element) {

            this.elementRef = element;
            this.manager.registerFolder(this);
        }
    }

    public unregisterFromDragDrop(): void {
        this.manager.unregisterFolder(this);
    }

}


interface IDragDropTargetCtrlProps {
    state: DragDropTargetState;
}

class DragDropTargetCtrl extends React.Component<IDragDropTargetCtrlProps, {}> {

    private elementRef = React.createRef<HTMLDivElement>();

    componentDidMount(): void {
        this.props.state.registerForDragDrop(this.elementRef.current);
    }

    componentWillUnmount(): void {
        this.props.state.unregisterFromDragDrop();
    }

    render() {

        const dropTargetStyle = this.props.state.isActive
            ? {
                backgroundColor: '#deecf9',
                border: '1px dashed #0078d4',
                borderRadius: '4px'
            }
            : {
                border: '1px dashed rgba(255, 255, 255, 0)',
            };

        return (
            <div
                ref={this.elementRef}
                className="outlookItemHoverForButtons outlookViewTextLabel"
                style={{ cursor: 'pointer', ...dropTargetStyle }}>

                {this.props.children}

            </div>
        );
    }
}

export default observer(DragDropTargetCtrl);

